import CopyToClipboard from "../../../Common/CopyToClipboard/CopyToClipboard";

export const ColumnHeaderCopyWrapper = (props: any) => {
    const { displayName } = props;

    return (
        <CopyToClipboard wrapper rightOffset="0px" autoCalcRightPosition={false}>
            <span className="ag-header-cell-text">{displayName}</span>
        </CopyToClipboard>
    );
};
